import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {factory} from '../app-logging';
import {HttpErrorResponse} from '@angular/common/http';
import {RedirectService} from '../../services/redirect.service';
import {ToastrService} from 'ngx-toastr';


const logger = factory.getLogger('GlobalErrorHandler');

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

  constructor(private injector: Injector) {
    super();
  }

  handleError(error: Error): void {
    const redirector: RedirectService = this.injector.get(RedirectService);
    const toastr: ToastrService = this.injector.get(ToastrService);

    logger.trace('Handling error');
    logger.error(error.message, error);
    if (error instanceof HttpErrorResponse) {
      const code = isNaN(error.status) ? NaN : error.status;
      switch (code) {
        case NaN:
          toastr.error('An unknown error rose while processing a request.', 'Unexpected response');
          break;
        case 0: // Possibly this is due to a CORS Error
          toastr.error('The request could not be fulfilled. It might be caused due to a ' +
            'Cross-Origin Resource Sharing error, please contact the service administrator.', 'CORS Error');
          redirector.goToErrorPage(error);
          break;
        default:
          toastr.error(error.message, error.name);
          break;
      }
    } else {
      toastr.error(error.message, error.name);
    }
    super.handleError(error);
  }
}
